import { useMutation } from "@tanstack/react-query";
import { insightsApi } from "../api";

export const useInsightsChatbot = () => {
  return useMutation({
    mutationFn: insightsApi.queryChatbot,
  });
};

